import React, { useState, useEffect } from "react";
import {
  Button,
  Card,
  Form,
  Container,
  Row,
  Col,
  FormGroup,
  Breadcrumb,
} from "react-bootstrap";
import {
  getExpediteVisitConfig,
  updateExpediteVisitOption,
} from "../../actions/expediteVisitAction";
import FullPageLoader from "../../components/FullPageLoader/FullPageLoader";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Link } from "react-router-dom";

const optionSchema = Yup.object().shape({
  title: Yup.string()
    .min(2, "Title must have at least 2 characters")
    .max(200, "Title can't be longer than 200 characters")
    .required("Title field is required"),
  timeZone: Yup.string()
    .min(2, "Time Frame must have at least 2 characters")
    .max(100, "Time Frame can't be longer than 100 characters")
    .required("Time Frame field is required"),
  description: Yup.string()
    .min(10, "Description must have at least 10 characters")
    .max(500, "Description can't be longer than 500 characters")
    .required("Description field is required"),
  // price: Yup.number()
  //   .required("Price field is required")
  //   .test("is-greater-than-zero", "Price must be greater than zero", function(value) {
  //     if (value === undefined || value === null) return false;
  //     return value > 0;
  //   }),
  "agreement.title": Yup.string()
    .max(200, "Agreement title can't be longer than 200 characters"),

  agreamentText: Yup.string()
    .min(2, "agreament Text must have at least 2 characters")
    .max(500, "agreament Text can't be longer than 500 characters")
    // .required("agreament Text field is required"),
});

const EditOption = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [loader, setLoader] = useState(false);
  const [optionData, setOptionData] = useState(null);
  const [agreementTerms, setAgreementTerms] = useState([""]);

  // Helper function to get timeZone value from optionData
  const getTimeZoneValue = (data) => {
    // First check if timeZone exists directly (new format)
    if (data?.timeZone) {
      return data.timeZone;
    }
    // Otherwise, check for old timeFrame format (backward compatibility)
    if (data?.timeFrame) {
      return data.timeFrame;
    }
    // Otherwise, construct from timeFrameFrom and timeFrameTo (old format for backward compatibility)
    if (data?.timeFrameFrom !== undefined && data?.timeFrameTo !== undefined) {
      return `${data.timeFrameFrom}-${data.timeFrameTo} minutes`;
    }
    return "";
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: optionData ? {
      title: optionData.title || "",
      timeZone: getTimeZoneValue(optionData),
      // suffix: optionData.suffix || "",
      description: optionData.description || "",
      agreamentText: optionData.agreamentText || "",
      price: optionData.price || 0,
      agreement: {
        title: optionData.agreement?.title || "",
        terms: [],
      },
    } : {
      title: "",
      timeZone: "",
      // suffix: "",
      description: "",
      agreamentText: "",
      price: 0,
      agreement: {
        title: "",
        terms: [],
      },
    },
    validationSchema: optionSchema,
    onSubmit: async (values) => {
      setLoader(true);
      const submitData = {
        ...values,
        agreement: {
          title: values.agreement.title || "Agreement",
          terms: agreementTerms.filter((term) => term.trim() !== ""),
        },
      };
      let res = await updateExpediteVisitOption(id, submitData);
      if (res?.data?.success) {
        navigate("/service-add-on");
        toast.success(res.data.message);
      }
      setLoader(false);
    },
  });

  useEffect(() => {
    const getOptionData = async () => {
      setLoader(true);
      let res = await getExpediteVisitConfig();
      if (res?.data?.data?.options) {
        const option = res.data.data.options.find(
          (opt) => (opt._id || opt.id) === id
        );
        if (option) {
          setOptionData(option);
          if (option.agreement && option.agreement.terms) {
            setAgreementTerms(
              option.agreement.terms.length > 0
                ? option.agreement.terms
                : [""]
            );
          } else {
            setAgreementTerms([""]);
          }
        }
      }
      setLoader(false);
    };
    if (id) {
      getOptionData();
    }
  }, [id]);

  const addAgreementTerm = () => {
    setAgreementTerms([...agreementTerms, ""]);
  };

  const removeAgreementTerm = (index) => {
    const newTerms = agreementTerms.filter((_, i) => i !== index);
    setAgreementTerms(newTerms.length > 0 ? newTerms : [""]);
  };

  const updateAgreementTerm = (index, value) => {
    const newTerms = [...agreementTerms];
    newTerms[index] = value;
    setAgreementTerms(newTerms);
  };

  if (!optionData && !loader) {
    return (
      <div className="pt-2 pt-md-3">
        <Container fluid>
          <Row>
            <Col md="12">
              <Card className="card">
                <Card.Body>
                  <p>Option not found.</p>
                  <Link to="/expedite-visit" className="btn btn-filled">
                    Back to Expedite Visit
                  </Link>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }

  return (
    <>
      {loader ? (
        <FullPageLoader />
      ) : (
        <div className="pt-2 pt-md-3 cms-updated-style">
          <Container fluid>
            <Row>
              <Col md="12">
                {/* <Breadcrumb className="care-md-breadcrumb">
                  <Link className="breadcrumb-item" to="/expedite-visit">
                    Expedite Visit
                  </Link>
                  <Breadcrumb.Item active>Edit Option</Breadcrumb.Item>
                </Breadcrumb> */}
                {/* <h3>Add Content Page</h3> */}
                <Card className="filter-card card">
                  <Card.Header>
                    <div className="d-flex align-items-center justify-content-between table-head">
                      <Card.Title className="text-white" as="h4">
                        Edit Service Add-on
                      </Card.Title>
                    </div>
                  </Card.Header>
                  <Card.Body>
                    <Row>
                      <Col>
                        <Form onSubmit={formik.handleSubmit}>
                          <Form.Group className="mb-3">
                            <Form.Label>
                              Title <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name="title"
                              placeholder="Enter add-on title"
                              onChange={formik.handleChange}
                              value={formik.values.title}
                              onBlur={formik.handleBlur}
                            />
                            {formik.touched.title && formik.errors.title ? (
                              <span className={formik.errors.title ? `` : `d-none`}>
                                <label className="pl-1 text-danger">
                                  {formik.errors.title}
                                </label>
                              </span>
                            ) : null}
                          </Form.Group>

                          <Form.Group className="mb-3">
                            <Form.Label>
                              Time Frame <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name="timeZone"
                              placeholder="e.g., under 10 minutes, 20-30 minutes, 2-3 hours"
                              onChange={formik.handleChange}
                              value={formik.values.timeZone}
                              onBlur={formik.handleBlur}
                            />
                            {formik.touched.timeZone && formik.errors.timeZone ? (
                              <span className={formik.errors.timeZone ? `` : `d-none`}>
                                <label className="pl-1 text-danger">
                                  {formik.errors.timeZone}
                                </label>
                              </span>
                            ) : null}
                          </Form.Group>

                          {/* <Form.Group className="mb-3">
                            <Form.Label>Suffix (Optional)</Form.Label>
                            <Form.Control
                              type="text"
                              name="suffix"
                              placeholder="e.g., processing time works for me"
                              onChange={formik.handleChange}
                              value={formik.values.suffix || ""}
                              onBlur={formik.handleBlur}
                            />
                          </Form.Group> */}

                          <Form.Group className="mb-3">
                            <Form.Label>
                              Description <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              as="textarea"
                              rows={4}
                              name="description"
                              placeholder="Enter description"
                              onChange={formik.handleChange}
                              value={formik.values.description}
                              onBlur={formik.handleBlur}
                            />
                            {formik.touched.description && formik.errors.description ? (
                              <span className={formik.errors.description ? `` : `d-none`}>
                                <label className="pl-1 text-danger">
                                  {formik.errors.description}
                                </label>
                              </span>
                            ) : null}
                          </Form.Group>

                          <Form.Group className="mb-3">
                            <Form.Label>
                              Price <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              type="number"
                              name="price"
                              placeholder="Enter the add-on price (i.e., 0.1, 0.2, 30, 49.99, etc.)"
                              min="0.01"
                             disabled={formik.values.price === 0}                             
                              step="0.01"
                              onChange={formik.handleChange}
                              value={formik.values.price}
                              onBlur={formik.handleBlur}
                            />
                            {formik.touched.price && formik.errors.price ? (
                              <span className={formik.errors.price ? `` : `d-none`}>
                                <label className="pl-1 text-danger">
                                  {formik.errors.price}
                                </label>
                              </span>
                            ) : null}
                          </Form.Group>

                          <Card className="mb-3">
                            <Card.Header>
                              <Card.Title as="h5">Agreement</Card.Title>
                            </Card.Header>
                            <Card.Body>
                              <Form.Group className="mb-3">
                                <Form.Label>Agreement Title (Optional)</Form.Label>
                                <Form.Control
                                  type="text"
                                  name="agreement.title"
                                  placeholder="Enter agreement title"
                                  onChange={formik.handleChange}
                                  value={formik.values.agreement?.title || ""}
                                  onBlur={formik.handleBlur}
                                />
                                {formik.touched["agreement.title"] && formik.errors["agreement.title"] ? (
                                  <span className={formik.errors["agreement.title"] ? `` : `d-none`}>
                                    <label className="pl-1 text-danger">
                                      {formik.errors["agreement.title"]}
                                    </label>
                                  </span>
                                ) : null}
                              </Form.Group>

                              <Form.Group className="mb-3">
                                <div className="d-flex justify-content-between align-items-center mb-2">
                                  <Form.Label>Agreement Terms</Form.Label>
                                  <Button
                                    type="button"
                                    variant="outline-primary"
                                    size="sm"
                                    onClick={addAgreementTerm}
                                  >
                                    Add Term
                                  </Button>
                                </div>
                                {agreementTerms.map((term, index) => (
                                  <div key={index} className="d-flex mb-2">
                                    <Form.Control
                                      type="text"
                                      placeholder="Enter agreement term"
                                      value={term}
                                      onChange={(e) => updateAgreementTerm(index, e.target.value)}
                                      className="mr-2"
                                    />
                                    <Button
                                      type="button"
                                      variant="danger"
                                      size="sm"
                                      onClick={() => removeAgreementTerm(index)}
                                    >
                                      Remove
                                    </Button>
                                  </div>
                                ))}
                              </Form.Group>
                            </Card.Body>
                          </Card>

                          <Form.Group className="mb-3">
                            <Form.Label>
                              Agreament Text
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name="agreamentText"
                              placeholder="Enter Agreament Text"
                              onChange={formik.handleChange}
                              value={formik.values.agreamentText}
                              onBlur={formik.handleBlur}
                            />
                            {formik.touched.agreamentText && formik.errors.agreamentText ? (
                              <span className={formik.errors.agreamentText ? `` : `d-none`}>
                                <label className="pl-1 text-danger">
                                  {formik.errors.agreamentText}
                                </label>
                              </span>
                            ) : null}
                          </Form.Group>

                          <Button className="btn-filled" type="submit">
                            Update
                          </Button>
                        </Form>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      )}
    </>
  );
};

export default EditOption;


